module.exports = __webpack_public_path__ + "static/media/PDF_65.eaf684e8.pdf";